import { createFileRoute } from '@tanstack/react-router'
import SuccessPage from '~/features/auth/pages/success';


export const Route = createFileRoute('/(auth)/_auth/success/$type')({
  validateSearch: () => ({}),

  loader: ({ params }) => {
    const type = params.type;
    if (type !== "reset" && type !== "update") {
      throw new Error("Invalid type parameter. Must be either 'reset' or 'update'");
    }
    return { type } as const;
  },
  
  component: function SuccessRoute() {
    const { type } = Route.useLoaderData();
    return <SuccessPage type={type} />;
  },

  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="flex min-h-screen w-full items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold">Signin Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
